__turbopack_context__.v({
  "alert-banner": "course-limited-access-module-scss-module__3NJB3W__alert-banner",
  "container": "course-limited-access-module-scss-module__3NJB3W__container",
  "heading": "course-limited-access-module-scss-module__3NJB3W__heading",
});
